





























































import { ShipmentCertificatesApi } from "../../apis";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonShipment extends Vue {

  get breakPointWidth() {
    return this.$vuetify.breakpoint.width;
  }

  get isNavShow() {
    return this.$store.getters.navbarShow;
  }

  get isAppendBtnTruncate() {
    return (this.breakPointWidth >= 1264 && this.breakPointWidth < 1366)
    || (this.isNavShow && this.breakPointWidth >= 1366 && this.breakPointWidth < 1600);
  }

  status_ = "";
  async created() {
    const {
      data: {
        data: { status },
      },
    } = await new ShipmentCertificatesApi().getShipmentCertificate({
      id: this.$route.params.id,
    });
    this.status_ = status;
  }

  get status() {
    return !this.status_ ? "" : this.status_;
  }

  onPreview() {
    this.$router.push({
      name: "certificate",
      params: { id: this.$route.params.id },
    });
  }

  onApprove() {
    this.$store.commit("APPROVE_SHIPMENT_CLICK");
  }

  onReject() {
    this.$store.commit("REJECT_SHIPMENT_CLICK");
  }

  onEdit() {
    this.$router.push({
      name: "edit-shipment",
      params: { id: this.$route.params.id },
      query: { t: "" + new Date().getTime() },
    });
  }
}
